import type { IconDefinition } from '../index.tsx';

export const iconEuro: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconEuro',
  icon: [
    16,
    16,
    [],
    '',
    'M10.1232 2.82003C8.40447 2.82003 6.86095 3.74568 5.96978 5.17005H12.2201V7.05007H5.2511C5.1979 7.35415 5.17005 7.66823 5.17005 7.99008C5.17005 8.31193 5.1979 8.62601 5.2511 8.93009H11.2801V10.8101H5.96978C6.86095 12.2345 8.40447 13.1601 10.1232 13.1601C11.2829 13.1601 12.3509 12.7455 13.2003 12.0414L15 14.2125C13.6706 15.3145 11.9731 15.9802 10.1232 15.9802C6.76846 15.9802 3.95291 13.8131 2.84948 10.8101H0V8.93009H2.40356C2.36819 8.62143 2.35002 8.30773 2.35002 7.99008C2.35002 7.67243 2.36819 7.35872 2.40356 7.05007H0.940009V5.17005H2.84948C3.95291 2.16706 6.76846 0 10.1232 0C11.9731 0 13.6706 0.66569 15 1.76768L13.2003 3.93875C12.3509 3.23465 11.2829 2.82003 10.1232 2.82003Z',
  ],
};
